import type { PropsWithChildren } from 'react'

export const SectionTitle = ({ children }: PropsWithChildren) => (
	<p className={'text-center text-2xl font-bold md:text-[36px]'}>{children}</p>
)
